  document.querySelectorAll('.reveal').forEach(function(el, i){
    setTimeout(function(){ el.classList.add('in'); }, 120 + i * 220);
  });

  /* Slide navigation + firm snapping are handled by CSS scroll-snap (mandatory)
     plus native in-page anchor scrolling — no JS needed. Cue links that point to
     other pages (patent, founder) navigate normally via the shared fade. */

  /* ─── INTELLIGENT PERFORMANCE VIDEO CONTROLLER ─── */
  (function(){
    /* The product page runs its own click-to-play reel, where only one film may
       play at a time. This controller plays everything that scrolls into view,
       which on that page meant five voices at once — so skip anything inside it.
       It also forces preload='metadata' below, overriding the reel's own
       preload='none'. */
    var vids = Array.prototype.filter.call(
      document.querySelectorAll('video:not(#heroVideo)'),
      function (v) { return !v.closest('.mdv-pdp'); }
    );
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var v = entry.target;
          if (entry.isIntersecting) {
            v.play().catch(function(){});
          } else {
            v.pause();
          }
        });
      }, { rootMargin: '120px 0px', threshold: 0.05 });
      vids.forEach(function(v){
        v.preload = 'metadata';
        videoObserver.observe(v);
      });
    } else {
      vids.forEach(function(v){ v.play().catch(function(){}); });
    }
  })();

  /* ─── PROMO RIBBON DISMISS ─── */
  function dismissPromoRibbon(){
    var ribbon = document.getElementById('promoRibbon');
    ribbon.classList.add('dismissed');
    setRibbonCookie('mdv_ribbon_dismissed', '1', 30);
  }

  function setRibbonCookie(name, value, days){
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getRibbonCookie(name){
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  if (getRibbonCookie('mdv_ribbon_dismissed')){
    document.getElementById('promoRibbon').classList.add('dismissed');
  }

  /* Product card carousel — arrows, dots, touch & mouse swipe, keyboard, click-to-expand lightbox */
  (function () {
    /* Shared Fullscreen Lightbox */
    var lightboxEl = null;
    var lbImg = null, lbCurrent = null, lbTotal = null;
    var lbSlides = [];
    var lbIndex = 0;
    var lbOnNavigate = null;

    function initLightbox() {
      if (lightboxEl) return;
      lightboxEl = document.createElement('div');
      lightboxEl.className = 'mdv-lightbox';
      lightboxEl.id = 'mdvLightbox';
      lightboxEl.setAttribute('aria-hidden', 'true');
      lightboxEl.setAttribute('role', 'dialog');
      lightboxEl.setAttribute('aria-modal', 'true');
      lightboxEl.setAttribute('aria-label', 'Photo preview');
      lightboxEl.innerHTML =
        '<div class="mdv-lightbox__backdrop"></div>' +
        '<button type="button" class="mdv-lightbox__close" aria-label="Close photo preview">&times;</button>' +
        '<button type="button" class="mdv-lightbox__arrow mdv-lightbox__prev" aria-label="Previous photo">&#8249;</button>' +
        '<button type="button" class="mdv-lightbox__arrow mdv-lightbox__next" aria-label="Next photo">&#8250;</button>' +
        '<div class="mdv-lightbox__stage">' +
          '<img class="mdv-lightbox__img" src="" alt="">' +
        '</div>' +
        '<div class="mdv-lightbox__counter"><span class="mdv-lightbox__current">1</span> / <span class="mdv-lightbox__total">1</span></div>';
      document.body.appendChild(lightboxEl);

      lbImg = lightboxEl.querySelector('.mdv-lightbox__img');
      lbCurrent = lightboxEl.querySelector('.mdv-lightbox__current');
      lbTotal = lightboxEl.querySelector('.mdv-lightbox__total');

      lbImg.addEventListener('click', function (e) { e.stopPropagation(); });
      lightboxEl.querySelector('.mdv-lightbox__stage').addEventListener('click', function (e) {
        if (e.target === this) closeLightbox();
      });

      lightboxEl.querySelector('.mdv-lightbox__close').addEventListener('click', closeLightbox);
      lightboxEl.querySelector('.mdv-lightbox__backdrop').addEventListener('click', closeLightbox);
      lightboxEl.querySelector('.mdv-lightbox__prev').addEventListener('click', function (e) {
        e.stopPropagation();
        showLightboxSlide(lbIndex - 1);
      });
      lightboxEl.querySelector('.mdv-lightbox__next').addEventListener('click', function (e) {
        e.stopPropagation();
        showLightboxSlide(lbIndex + 1);
      });

      document.addEventListener('keydown', function (e) {
        if (!lightboxEl || !lightboxEl.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          showLightboxSlide(lbIndex - 1);
        } else if (e.key === 'ArrowRight') {
          showLightboxSlide(lbIndex + 1);
        }
      });

      var lbStartX = 0, lbDx = 0;
      lightboxEl.addEventListener('touchstart', function (e) {
        lbStartX = e.touches[0].clientX;
        lbDx = 0;
      }, { passive: true });
      lightboxEl.addEventListener('touchmove', function (e) {
        lbDx = e.touches[0].clientX - lbStartX;
      }, { passive: true });
      lightboxEl.addEventListener('touchend', function () {
        if (Math.abs(lbDx) > 40) {
          showLightboxSlide(lbIndex + (lbDx < 0 ? 1 : -1));
        }
      });
    }

    function openLightbox(slides, startIndex, onNavigate) {
      initLightbox();
      lbSlides = slides;
      lbTotal.textContent = slides.length;
      lbOnNavigate = onNavigate;
      showLightboxSlide(startIndex);
      lightboxEl.classList.add('is-open');
      lightboxEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightboxEl) return;
      lightboxEl.classList.remove('is-open');
      lightboxEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showLightboxSlide(idx) {
      if (!lbSlides.length) return;
      lbIndex = (idx + lbSlides.length) % lbSlides.length;
      var slide = lbSlides[lbIndex];
      lbImg.style.opacity = '0';
      lbImg.src = slide.src;
      lbImg.alt = slide.alt || '';
      lbCurrent.textContent = lbIndex + 1;
      if (lbImg.complete) {
        lbImg.style.opacity = '1';
      } else {
        lbImg.onload = function () { lbImg.style.opacity = '1'; };
      }
      if (typeof lbOnNavigate === 'function') {
        lbOnNavigate(lbIndex);
      }
    }

    /* Initialize each card carousel */
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('.carousel-track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;

      var dotsWrap = root.querySelector('.carousel-dots');
      var prev = root.querySelector('.carousel-arrow.prev');
      var next = root.querySelector('.carousel-arrow.next');
      var index = 0, startX = 0, dx = 0, dragging = false, moved = false, width = 0;
      var downTarget = null;

      // Prevent default image drag
      slides.forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      var dots = slides.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        b.setAttribute('aria-label', 'Go to photo ' + (i + 1));
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          go(i);
        });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });

      function render(animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
      }
      function go(i) { index = (i + slides.length) % slides.length; render(true); }

      if (prev) prev.addEventListener('click', function (e) {
        e.stopPropagation();
        go(index - 1);
      });
      if (next) next.addEventListener('click', function (e) {
        e.stopPropagation();
        go(index + 1);
      });

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (lightboxEl && lightboxEl.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') { go(index - 1); }
        else if (e.key === 'ArrowRight') { go(index + 1); }
      });

      function onMouseMove(e) { move(e.clientX); }
      function onMouseUp() { end(); }

      function start(x, target) {
        dragging = true;
        moved = false;
        startX = x;
        dx = 0;
        downTarget = target;
        width = root.clientWidth || 1;
        track.style.transition = 'none';
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      }
      function move(x) {
        if (!dragging) return;
        dx = x - startX;
        if (Math.abs(dx) > 6) {
          moved = true;
        }
        track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
      }
      function end() {
        if (!dragging) return;
        dragging = false;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);

        if (moved && Math.abs(dx) > width * 0.18) {
          go(index + (dx < 0 ? 1 : -1));
        } else if (moved) {
          render(true);
        } else {
          // Intentional click/tap without dragging -> open lightbox or navigate
          render(true);
          var link = root.getAttribute('data-carousel-link');
          if (link) {
            window.location.href = link;
            return;
          }
          if (downTarget && track.contains(downTarget)) {
            var img = downTarget.closest ? downTarget.closest('img') : (downTarget.tagName === 'IMG' ? downTarget : null);
            if (img && track.contains(img)) {
              var clickedIdx = slides.indexOf(img);
              if (clickedIdx === -1) clickedIdx = index;
              var slideData = slides.map(function (s) {
                return { src: s.getAttribute('src'), alt: s.getAttribute('alt') || '' };
              });
              openLightbox(slideData, clickedIdx, function (newIdx) {
                go(newIdx);
              });
            }
          }
        }
      }

      track.addEventListener('touchstart', function (e) {
        start(e.touches[0].clientX, e.target);
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        move(e.touches[0].clientX);
      }, { passive: true });
      track.addEventListener('touchend', end);
      track.addEventListener('touchcancel', end);

      track.addEventListener('mousedown', function (e) {
        start(e.clientX, e.target);
      });

      render(false);
    });
  })();

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.wall-sound-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var video = document.getElementById(btn.getAttribute('data-video-target'));
        if(!video) return;
        video.loop = false;
        video.muted = false;
        video.controls = true;
        video.currentTime = 0;
        video.play();
        btn.closest('.wall-tile--full-review').classList.add('is-playing-full');
      });
    });
  });

